module.exports = __webpack_public_path__ + "static/img/mb_um_mission2.72a46008.png";